// @flow
import { all } from 'redux-saga/effects';

import authSaga from './auth/saga';
import wareHouseSaga from './wareHouse/saga';
import boundSaga from './InboundOutbound/saga';
import clientSaga from './client/saga';
import commoditySaga from './commodity/saga';
import commodityCategorySaga from './commodityCategory/saga';
import unitSaga from './unit/saga';
import inventorySaga from './inventory/saga';
import dashboardSaga from './Dashboard/saga';
import supportSaga from './Help&Support/saga';
import companySaga from './company/saga'
import stockSaga from './stock/saga';
import historySaga from './TransactionHistory/saga';
import userSaga from './users/saga';
import downloadCsvSaga from './downloadCSV/saga';
import reportsSaga from './reports/saga';
import tagSearchSaga from './tagSearch/saga';
export default function* rootSaga(): any {
    yield all([
        authSaga(),
        wareHouseSaga(),
        boundSaga(),
        clientSaga(),
        commoditySaga(),
        commodityCategorySaga(),
        unitSaga(),
        inventorySaga(),
        dashboardSaga(),
        supportSaga(),
        companySaga(),
        stockSaga(),
        historySaga(),
        userSaga(),
        downloadCsvSaga(),
        reportsSaga(),
        tagSearchSaga(),
    ]);
}
